import Bold from '../../atoms/text/bold';
import Container from '../../atoms/container/recordingModalChannelContainer';
import EpgEvent from '../../../../shared/classes/epgEvent';
import FastEvent from '../../../../shared/classes/fastEvent';
import Info from '../../atoms/text/recordingModalChannelInfo';
import Logo from '../../atoms/images/modalLogo';
import MediaProduction from '@shared/classes/mediaProduction';
import Title from '../../atoms/text/recordingModalChannelTitle';
import { useMemo } from 'react';

const MILLISECONDS_TO_MINUTES = 60 * 1000;

interface Props {
  asset?: EpgEvent | FastEvent | MediaProduction;
}

export default function RecordingModal({ asset }: Props) {
  const { duration, episode, season, title } = useMemo(() => {
    const { date } = asset || {};
    const { end, start } = date || {};
    const duration =
      ((asset as MediaProduction)?.duration ||
        (end && start
          ? `${Math.round((end - start) / MILLISECONDS_TO_MINUTES)}`
          : '')) + ' min';
    let episode = asset?.episodeNumber || '';
    episode = episode ? 'E' + episode : '';
    let season = asset?.seasonNumber || '';
    season = season ? 'S' + season : '';
    const title = asset?.title;
    return { duration, episode, season, title };
  }, [asset]);

  return (
    <Container>
      <Logo src={asset?.channel?.logo} />
      <Title>{title}</Title>
      <Info>
        {`${episode}${episode && season && ' | '}${season}`}
        <Bold>{(episode || season) && duration && ' · '}</Bold>
        {duration}
      </Info>
    </Container>
  );
}
